import { once } from 'lodash-es'
import type { ReadServerRenderedWorkspaceFn } from '@/features/iam'
import type { WorkspaceStore } from '@/features/iam/workspaces/WorkspaceStore'
import { mapWorkspaceResourceToProps } from '@/features/iam/workspaces/workspace-mappers'

/**
 * Creates a reader for the workspace of the custom domain the app is served
 * from.
 *
 * @param workspaceStore
 */
export function createServerRenderedWorkspaceReader(
  workspaceStore: Pick<WorkspaceStore, 'workspaces'>,
): ReadServerRenderedWorkspaceFn {
  return once(() => {
    const resource = window.__workspaceDomain?.workspace
    return resource
      ? workspaceStore.workspaces.set(mapWorkspaceResourceToProps(resource))
      : null
  })
}
